import { StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import Translator from './Translator';

type CssClasses = 'addressPage' ;
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({

  addressPage: {
    fontSize: '17px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: '#666',
    marginTop: '25px'
  },
});

interface OwnProps {

}

class FintechOneAddress extends React.Component<OwnProps & WithStyles<CssClasses>> {
  render() {
    let { classes } = this.props;
    return (
      <Translator>
        {translate => {
          return (
            <div className={classes.addressPage}>
              <b>{translate('contactCompanyName')}</b>
              <br />
              {translate('contactAddress')}
              <br />
              {translate('contactZipCodeCity')}
              <br />
              {translate('contactCountry')}
              <br />
            </div>
          );
        }}
      </Translator>
    );
  }
}

export default pure(withStyles(styles)(FintechOneAddress));



// WEBPACK FOOTER //
// ./src/components/FintechOneAddress.tsx